import { useTranslation } from 'next-i18next';
import { BenefitsBlock } from '@/widgets/BenefitsBlock';
import { MetaDecorator } from '@/shared/utils';
import { getReviewsBenefits } from '../lib/reviewsBenefits';

const ReviewsProductPage = () => {
  const { t } = useTranslation();
  const reviewsBenefits = getReviewsBenefits(t);
  const heading = t('productPages.reviews.heading');
  const highlight = t('productPages.reviews.highlight', {
    returnObjects: true,
  }) as string[];

  return (
    <>
      <MetaDecorator
        description='meta.products.reviews.description'
        keywords='meta.products.reviews.keywords'
        title='meta.products.reviews.title'
      />
      <BenefitsBlock
        benefits={reviewsBenefits}
        heading={heading}
        headingAs='h1'
        highlight={highlight}
        subHeadingAs='h2'
      />
    </>
  );
};

export default ReviewsProductPage;
